<!--
 * @Author: Tina Huang
 * @Date: 2023-01-02 12:37:44
 * @LastEditors: Tina Huang
 * @LastEditTime: 2023-11-10 15:26:35
 * @Description: 
-->
<template>
  <div class="container dialog-container" v-show="show">
    <div class="mask"></div>
    <div class="dialog-content code-content">
      <span class="btn-close" @click="close"
        ><i class="el-icon-close"></i
      ></span>
      <h2>𝕎𝕚𝕕𝕧𝕖𝕣𝕤𝕖 · 汪汪汪世界</h2>
      <div class="form-box">
        <el-input
          placeholder="请输入访问口令"
          v-model="code"
          class="input-with-select"
        >
          <el-button
            data-splitbee-event="Enter code"
            type="primary"
            slot="append"
            icon="el-icon-right"
            @click="checkCode"
          ></el-button>
        </el-input>
      </div>
      <p type="danger" style="color: red; font-size: 14px">口令区分大小写</p>
      <p class="msg">
        组件库的<strong>访问口令会不定期进行更新, </strong>
        <el-popover placement="top" trigger="hover">
          <div>
            <p>微信扫一扫获取最新口令</p>
            <el-image
              style="width: 150px; display: block; margin: 0 auto"
              :src="CodeImage"
              fit="fill"
            ></el-image>
          </div>
          <el-button type="primary" round slot="reference"
            >👉 获取最新口令</el-button
          >
        </el-popover>
      </p>
      <br />
      <p class="msg">
        小红书：<a
          target="blank"
          href="https://www.xiaohongshu.com/user/profile/5c049fc9000000000800af53?xhsshare=WeixinSession&appuid=5c049fc9000000000800af53&apptime=1664074455"
          >@肥汪卷</a
        >
        ｜ B站：<a
          href="https://space.bilibili.com/19225439?spm_id_from=333.1007.0.0"
          target="blank"
          >@阿汪同学</a
        >
        | 微信公众号：<a href="#">汪汪汪世界</a>
      </p>
    </div>
  </div>
</template>
<script>
import md5 from "js-md5";
export default {
  data() {
    return {
      show: false,
      code: "",
      CodeImage: require("../assets/code.png"),
    };
  },
  methods: {
    open() {
      console.log("open");
      this.show = true;
    },
    close() {
      this.show = false;
    },
    checkCode() {
      splitbee.track("Enter code");
      const _this = this;
      if (!this.code)
        return this.$message({
          message: "请输入正确的访问口令",
          center: true,
          type: "error",
        });
      if (md5(this.code) === this.$token || md5(this.code) === this.$admin) {
        this.$message({ message: "访问成功", center: true, type: "success" });
        localStorage.setItem("token", md5(this.code));
        setTimeout(function () {
          _this.close();
          _this.successGo();
        }, 2000);
      } else {
        return this.$message({
          message: "口令错误或口令已过期",
          center: true,
          type: "error",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.dialog-container .code-content {
  width: 580px;
  padding: 20px;
  text-align: center;
  a {
    color: #848fe0;
  }
}
.btn-close {
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
}
.form-box {
  margin-bottom: 20px;
}
.input-with-select {
  width: 50%;
}
@media (max-width: 767px) {
  .dialog-container .code-content {
    width: 300px;
  }
  .input-with-select {
    width: 100%;
  }
}
</style>
